function HeaderTitle(){
    return  <>
      <h1 className='title-app'>Select and split your costs</h1>
     
    </>
}
export default HeaderTitle;
  